import api from '../../api/api';
import { urlParamsFormatter } from '../../app/utility/string';
import filterBuilder from "../../app/utility/filter-builder";
import { sortDateAscending, sortDateDescending } from '../../app/utility/sort-by-date';
import filterByProperty from '../../app/utility/filter-by-property';

import { Response, ListItem } from './top-search.interface';
import TextField from './text-field';
import FilterButton from './filter-button';
import template from './top-search.template';
import Selectbox from './selectbox';
import ResetSearchButton from './resetSearchButton';
import SpellSuggestion from './spell-suggestion';

export default class TopSearch {
  response: Response;
  listItems: ListItem[];
  isLoading: boolean = false;
  currentPage: number = 1;
  filters: {[prop: string]: any} = {
    query: ''
  };
  debounceTime: ReturnType<typeof setTimeout> = null;
  endPoint: string;
  endPage: string;
  resultList: HTMLElement;
  searchPageUrl: string;
  pageType: string[] = [];
  orderValue: string = 'all';
  resultSection: HTMLElement;
  pageSearchLinks: HTMLCollection;
  spellSuggestion: SpellSuggestion;

  constructor() {
    this.setEndPoints();
    this.setResultList();
    new TextField(
      (document.getElementById('js-top-search-form-field') as HTMLInputElement),
      {
        onFilterChanged: this.onFilterChanged.bind(this),
        resetAll: this.resetAll.bind(this)
      }
    );
    Array.from(document.getElementsByClassName('js-filter-button')).forEach((item) => {
      return new FilterButton(
        (item as HTMLButtonElement),
        {
          resetFilters : this.resetFilters.bind(this),
          updateFilters: this.updateFilters.bind(this),
          hideResetButton: this.hideResetButton.bind(this),

        }
      );
    });
    new Selectbox(document.getElementById('select-component-top-search'), {
      orderValueHandler: this.orderValueHandler.bind(this)
    });
    new ResetSearchButton({
      resetAll: this.resetAll.bind(this),
    });
    this.resultSection = document.getElementById('js-search-results');
    this.pageSearchLinks = document.getElementsByClassName('js-page-search');
  }

  setEndPoints() {
    const searchOverlay = document.getElementById('search-overlay');
    if(searchOverlay) {
      const endPoint = searchOverlay.getAttribute('data-endpoint') || null;
      const endPage = searchOverlay.getAttribute('data-page') || null;

      if(endPoint || endPage) {
        this.endPoint = endPoint;
        this.endPage = endPage;
        this.searchPageUrl = this.endPage + "?query=" + encodeURIComponent(this.filters.query)
      }
    }
  }

  setResultList = () => {
    this.resultList = document.getElementById('js-result-list');
  }

  setPageType = (filterValues: string[]) => {
    if (!this.pageType) {
      this.pageType = [];
    }

    this.pageType = Array.from(
      new Set([...this.pageType, ...filterValues]),
    );
  }

  orderValueHandler = (value: string) => {
    this.orderValue = value;
    this.render(this.filterResults(this.listItems));
  }

  updatePageSearchLinks() {
    Array.from(this.pageSearchLinks).forEach(link => link.setAttribute('href', this.searchPageUrl + encodeURIComponent(this.filters.query)))
  }

  /**
   * Fetch results with endpoint and filters
   */
   fetchResults = async() => {
    const params = {
      page: this.currentPage,
      ...this.filters,
    };
    clearTimeout(this.debounceTime);
    this.debounceTime = setTimeout(async() => {
      try {
        this.isLoading = true;
        const url = urlParamsFormatter(this.endPoint, params);
        const response = await api.get(url);
        this.response = response.data;
        this.listItems = response.data.items;
        this.isLoading = false;
        this.resultSection.classList.remove('hidden');
        this.updatePageSearchLinks();
        SpellSuggestion.render(this.response?.spellSuggestions?.params, this.searchPageUrl);
        this.render(this.filterResults(this.listItems));
      } catch (error) {
        this.isLoading = false;
      // Error handler
      }
    }, 400);
  };

  onFilterChanged = (value: string, filterProp: string) => {
    if (filterProp) {
      this.filters[filterProp] = value;
      this.currentPage = null;
      this.fetchResults();
    }
  };

  render = (items: ListItem[]) => {
    const templateResults = template(items);
    this.resultList.innerHTML = templateResults;
  }

  hideResetButton() {
    const resetButton = document.getElementsByClassName('js-reset')[0];
    resetButton.classList.add('hidden');
  }

  // Filters
  sortResults = (items: ListItem[], formater: any) => items.sort(formater);

  resetFilters = () => {
    this.pageType = [];
    this.orderValue = 'all';
    this.render(this.filterResults(this.listItems));
  }

  resetAll() {
    this.pageType = [];
    this.orderValue = 'all';
    this.filters.query = '';
    this.listItems = [];
    this.resultSection.classList.add('hidden');
    Array.from(document.getElementsByClassName('js-filter-button')).forEach((item) => item.classList.remove('active'));
    this.hideResetButton();
    $(document.getElementById('select-component-top-search')).val('all').trigger('change');
    (document.getElementById('js-top-search-form-field') as HTMLInputElement).value = '';

  }

  updateFilters = (filterValues: string[]) => {
    this.pageType = Array.from(new Set([...this.pageType, ...filterValues]));
    this.render(this.filterResults(this.listItems));
  }


  filterByDate = (items: ListItem[]) => {
    if (this.orderValue === 'oldest') {
      return this.sortResults(items, sortDateAscending);
    }
    if (this.orderValue === 'newest') {
      return this.sortResults(items, sortDateDescending);
    }
    return items;
  };

  filterByPageType = (items: ListItem[]) => filterByProperty(items, this.pageType, 'documentType');

  filterResults = (items: ListItem[]): ListItem[] => {
    return filterBuilder([
      this.filterByDate,
      this.filterByPageType,
      (items: ListItem[]) => items.slice(0, 4)
    ],
    items
    )
  }
}
